import React, { Suspense, lazy } from "react";
import { ThemeProvider } from "./context/ThemeContext";
import { SystemProvider } from "./win11/system";
import { ViewModeProvider, useViewMode } from "./ViewMode";
import Portfolio from "./pages/Portfolio";
import Win11 from "./win11/Win11";
import "./App.css";

// three.js is a large dependency and only the immersive face needs it, so it
// stays out of the initial bundle for anyone landing in classic or desktop mode.
const Immersive = lazy(() => import("./immersive/Immersive"));

function Screen() {
  const { mode } = useViewMode();
  if (mode === "windows") return <Win11 />;
  if (mode === "classic") return <Portfolio />;
  return (
    <Suspense fallback={<div className="imx-boot" aria-label="Loading" />}>
      <Immersive />
    </Suspense>
  );
}

function App() {
  return (
    <ThemeProvider>
      <SystemProvider>
        <ViewModeProvider>
          <Screen />
        </ViewModeProvider>
      </SystemProvider>
    </ThemeProvider>
  );
}

export default App;
